import { FirebaseDataService } from "../../services/firebase-data.service";

const firebaseDataService = new FirebaseDataService();

export async function fetchUserSavedDesignsData(statsObj) {
  try {
    const data = await firebaseDataService.getDataFromFirebaseDB(statsObj);
    console.log("fetchUserSavedDesignsData data", data);
    return ({ data });
  } catch (error) {
    throw error;
  }
}
  
export async function updateUserSavedDesignsData(statsObj, payload) {
  try {
    const data = await firebaseDataService.updateDataInDB(statsObj, payload);
    return ({ data });
  } catch (error) {
    throw error;
  }
}

export async function deleteUserSavedDesignsData(statsObj) {
  try {
    const response = await firebaseDataService.deleteDataInDB(statsObj);
    return ({ response });
  } catch (error) {
    throw error;
  }
}

